import React from "react";
import { Form, Input, Select, Card, Checkbox, Switch } from "antd";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import { CloseOutlined } from "@ant-design/icons";
import { useState } from "react";

const transformData = (data) => {
  return data.map(({ isoCode, name }) => {
    if (isoCode) return { value: isoCode, label: name };
    else return { value: name, label: name };
  });
};

const VerifierBody = ({
  Country,
  sameAsAbove,
  onSameAsAbove,
  registries,
  verificationBodies,
  editable,
  customInput,
  setCustomInput,
  form,
}) => {
  // console.log(editable);
  const countries = Country.getAllCountries();
  const inputClass = "border-0 border-b-2 rounded-none";
  const [selectedOrganisation, setSelectedOrganisation] = useState("");
  const [useCustomInput, setUseCustomInput] = useState({});

  const resetOrganisationState = () => {
    setSelectedOrganisation({});
  };

  const handleOrganisationChange = (key, value) => {
    setSelectedOrganisation((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    if (value === "others") {
      setUseCustomInput((prevState) => ({
        ...prevState,
        [key]: true,
      }));
      setCustomInput((prevState) => ({
        ...prevState,
        [key]: "", // Clear custom input when "Others" is selected
      }));
    } else {
      setUseCustomInput((prevState) => ({
        ...prevState,
        [key]: false,
      }));
    }
  };

  const onValidatorChange = () => {
    if (sameAsAbove) {
      const data = form.getFieldValue("validation_body");
      const customInputs = customInput || {};
      const verifierData = data.map((item, index) => ({
        ...item,
        organisation_name:
          item.organisation_name === "Others"
            ? customInputs[index] || "Others"
            : item.organisation_name,
      }));
      form.setFieldsValue({ verifier_body: verifierData });
    }
  };

  const handleCustomInputChange = (key, value) => {
    const processedValue = value.toLowerCase().replace(/\s+/g, "_");
    setCustomInput((prevState) => ({
      ...prevState,
      [key]: processedValue,
    }));
  };

  return (
    <Form.Item
      label={
        <div className="flex items-center">
          <h4 className="text-2xl font-semibold mb-2">Verification Body</h4>
          <Checkbox
            className="ml-4 h-fit"
            checked={sameAsAbove}
            onChange={(e) => {
              onSameAsAbove(e.target.checked);
              resetOrganisationState();
              onValidatorChange(); // Reset state on checkbox change
            }}
            disabled={editable}
          >
            <p className="font-normal text-sm text-black align-text-bottom">
              Same as above    {" "}
              <span className="text-blue-800">
                ( if selected others in the above validations,<span className="text-red-500"> then organisation name
                should enter manually )</span>
              </span>
            </p>
          </Checkbox>
        </div>
      }
      labelCol={{ span: 24 }}
      required
      className="pt-3"
    >
      <Form.List name="verifier_body">
        {(fields, { add, remove }) => (
          <div className="w-full">
            {fields.map(({ key, name, ...restField }, index) => (
              <Card
                className="mb-4"
                size="small"
                title={`Verification Body ${index + 1}`}
                key={key}
                extra={
                  <CloseOutlined
                    className={`${index === 0 && "hidden"}`}
                    onClick={() => {
                      remove(name);
                    }}
                  />
                }
              >
                <div className="w-full">
                  <div className="flex justify-start gap-1">
                    <Form.Item
                      {...restField}
                      name={[name, "organisation_name"]}
                      className="w-full"
                      rules={[
                        {
                          required: true,
                          message: "Please select or enter organization name",
                        },
                      ]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 7 }}
                    >
                      {(useCustomInput[key] || (sameAsAbove  &&  customInput[key] !=="")) ? (
                        <>
                          <Input
                            placeholder="Enter custom organization"
                            value={customInput[key] || ""}
                            onChange={(e) =>
                              handleCustomInputChange(key, e.target.value)
                            }
                            className="border-0 border-b-2 rounded-none"
                          />
                          <Switch
                            checkedChildren="Use Dropdown"
                            unCheckedChildren="Use Input"
                            checked={(useCustomInput[key] || (sameAsAbove  &&  customInput[key] !==""))}
                            onChange={() =>
                              setUseCustomInput((prevState) => ({
                                ...prevState,
                                [key]: !prevState[key],
                              }))
                            }
                          />
                        </>
                      ) : (
                        <Select
                          showSearch
                          optionFilterProp="label"
                          className="primary_variant w-full"
                          suffixIcon={
                            <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                          }
                          placeholder="Select organization"
                          options={verificationBodies}
                          onChange={(value) =>
                            handleOrganisationChange(key, value)
                          }
                          value={
                            selectedOrganisation[key] === "others"
                              ? "others"
                              : selectedOrganisation[key]
                          }
                          disabled={useCustomInput[key]} // Disable dropdown if 'Others' is selected
                        />
                      )}
                    </Form.Item>
                  </div>
                  <h5 className="mb-2">Auditor details</h5>
                  <div className="flex" key={key}>
                    <Form.Item
                      {...restField}
                      className="w-[calc(30%)] mr-6"
                      name={[name, "name"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter name",
                        },
                      ]}
                    >
                      <Input
                        disabled={sameAsAbove || editable}
                        className={inputClass}
                        placeholder="Name"
                      />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      initialValue={"91"}
                      name={[name, "country_code"]}
                      className="w-[8%] mr-2"
                      rules={[
                        {
                          required: true,
                          message: "Please select phone code",
                        },
                      ]}
                    >
                      <Select
                        disabled={sameAsAbove || editable}
                        className="secondary_variant"
                        suffixIcon={
                          <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                        }
                        placeholder={"Select Code"}
                      >
                        {countries.map((ele, index) => (
                          <Select.Option
                            key={`option_${index}`}
                            value={ele.phonecode}
                          >
                            {ele.flag} +{ele.phonecode}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      className="w-[30%] pr-6"
                      name={[name, "phone_number"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter contact number",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter a valid contact number",
                        },
                      ]}
                    >
                      <Input
                        disabled={sameAsAbove || editable}
                        placeholder="Contact no."
                        className={inputClass}
                      />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      className="w-[30%] mr-2"
                      name={[name, "email"]}
                      rules={[
                        {
                          type: "email",
                          message: "The input is not a valid email",
                        },
                        {
                          required: true,
                          message: "Please enter your email",
                        },
                      ]}
                    >
                      <Input
                        disabled={sameAsAbove || editable}
                        className={inputClass}
                        type="email"
                        placeholder="Email-id"
                      />
                    </Form.Item>
                  </div>
                  <h5 className="mb-2">Authorized from which Registry</h5>
                  <Form.Item
                    {...restField}
                    name={[name, "authorized_registry_name"]}
                    rules={[
                      {
                        required: true,
                        message: "Please select one option",
                      },
                    ]}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 7 }}
                  >
                    <Select
                      showSearch
                      optionFilterProp="label"
                      disabled={sameAsAbove || editable}
                      className="primary_variant"
                      suffixIcon={
                        <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                      }
                      placeholder={"Name"}
                      options={registries}
                    />
                  </Form.Item>
                  <h5 className="mb-2">Address details</h5>
                  <div className="flex mt-2 gap-x-6">
                    <Form.Item
                      className="w-full"
                      name={[name, "address_line"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter address Line",
                        },
                      ]}
                    >
                      <Input
                        disabled={sameAsAbove || editable}
                        placeholder="Address line"
                        className={inputClass}
                      />
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      className="w-full"
                      name={[name, "city"]}
                      rules={[
                        {
                          required: true,
                          message: "Please enter city",
                        },
                      ]}
                    >
                      <Input
                        disabled={sameAsAbove || editable}
                        className={inputClass}
                        placeholder="City"
                      />
                    </Form.Item>
                    <Form.Item
                      className="w-full"
                      name={[name, "country"]}
                      rules={[
                        {
                          required: true,
                          message: "Please select country",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        optionFilterProp="label"
                        disabled={sameAsAbove || editable}
                        className="primary_variant"
                        suffixIcon={
                          <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                        }
                        placeholder={"Country"}
                        options={transformData(countries)}
                      />
                    </Form.Item>
                  </div>
                </div>
              </Card>
            ))}

            <button
              onClick={() => add()}
              type="button"
              className="w-full h-7 bg-blue-200 rounded-lg text-blue-800  font-bold text-xs flex justify-center items-center"
              disabled={editable}
            >
              + Add Another Verifier
            </button>
          </div>
        )}
      </Form.List>
    </Form.Item>
  );
};

export default VerifierBody;
